module.exports = __webpack_public_path__ + "img/8b.abb710ac.svg";